import { cancelOtherReason } from '../CancelAppointmentReasons.js';

const getCancellationReasonValue = ({ formState  })=>{
    var ref, ref1;
    const cancellationReason = (ref = formState.cancellationReason) === null || ref === void 0 ? void 0 : ref.value;
    const otherCancellationReason = (ref1 = formState.otherCancellationReason) === null || ref1 === void 0 ? void 0 : ref1.value;
    if (cancellationReason === cancelOtherReason) {
        return otherCancellationReason || cancellationReason;
    }
    return cancellationReason || otherCancellationReason;
};

export { getCancellationReasonValue };
//# sourceMappingURL=get-cancellation-reason-value.js.map
